import {
  CircleCheck,
  Info,
  Loader2,
  OctagonX,
  TriangleAlert,
} from "lucide-react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-card/80 group-[.toaster]:backdrop-blur-xl group-[.toaster]:text-card-foreground group-[.toaster]:border group-[.toaster]:border-border/50 group-[.toaster]:shadow-lg group-[.toaster]:rounded-2xl",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:rounded-xl group-[.toast]:font-medium group-[.toast]:px-3 group-[.toast]:py-1.5 group-[.toast]:text-sm group-[.toast]:shadow-sm hover:group-[.toast]:bg-primary-hover",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:rounded-xl",
          success:
            "group-[.toaster]:!bg-[#e8f9ed]/70 group-[.toaster]:!text-[#34c759] group-[.toaster]:!border-[#34c759]/20 dark:group-[.toaster]:!bg-[#34c759]/10 dark:group-[.toaster]:!text-[#4cd964]",
          error:
            "group-[.toaster]:!bg-[#ffebe9]/70 group-[.toaster]:!text-[#ff3b30] group-[.toaster]:!border-[#ff3b30]/20 dark:group-[.toaster]:!bg-[#ff3b30]/10 dark:group-[.toaster]:!text-[#ff6961]",
          warning:
            "group-[.toaster]:!bg-[#fff9e6]/70 group-[.toaster]:!text-[#b8860b] group-[.toaster]:!border-[#ffcc00]/20 dark:group-[.toaster]:!bg-[#ffcc00]/10 dark:group-[.toaster]:!text-[#ffd60a]",
          info:
            "group-[.toaster]:!bg-[#f5f5ff]/70 group-[.toaster]:!text-[#5856d6] group-[.toaster]:!border-[#5856d6]/20 dark:group-[.toaster]:!bg-[#5856d6]/10 dark:group-[.toaster]:!text-[#a8a8ff]",
        },
      }}
      icons={{
        success: <CircleCheck className="h-4 w-4" />,
        info: <Info className="h-4 w-4" />,
        warning: <TriangleAlert className="h-4 w-4" />,
        error: <OctagonX className="h-4 w-4" />,
        loading: <Loader2 className="h-4 w-4 animate-spin" />,
      }}
      style={
        {
          "--border-radius": "1rem",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };

